import axios from "axios";
import { toast } from "sonner";
import handleErrors from "./handleErrors";

// This function does a CRUD operation and brings back the updated data
export async function apiFunction({
  method,
  endpoint,
  bodyData = {},
  params = {},
  setData,
  apiParams = {},
}) {
  try {
    const axiosOptions = {
      method,
      url: `${process.env.REACT_APP_BACKEND_URL}/${endpoint}`,
      data: bodyData,
    };

    if (method === "GET" && params) axiosOptions.params = params;
    const { data: fetchedData } = await axios(axiosOptions);
    const { page, itemsPerPage } =
      bodyData.apiParams || params.apiParams || apiParams;

    if (itemsPerPage) {
      setData([
        ...Array.from({ length: page * itemsPerPage }, () => ({})),
        ...fetchedData.rows,
        ...Array.from(
          { length: fetchedData.count - (page + 1) * itemsPerPage },
          () => ({})
        ),
      ]);
    } else {
      setData(fetchedData.rows);
    }

    if (fetchedData.success === true) {
      toast.success(fetchedData.successMessage);
    }
  } catch (error) {
    console.log("An error occurred: ", error, error.response.status);
    handleErrors({ error });
  }
}
